// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import Icon from '../Icon';
import { useInternalTranslate } from '../LocaleProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const TabClose = _ref => {
  let {
    tabMode,
    onClose,
    baseClassName
  } = _ref;
  const translate = useInternalTranslate('Tabs');
  if (typeof onClose !== 'function') {
    return null;
  }
  return /*#__PURE__*/_jsx("button", {
    "aria-label": translate('closeButton'),
    className: `${baseClassName}__${tabMode}-close`,
    type: "button",
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
      onClose(e);
    },
    children: /*#__PURE__*/_jsx(Icon, {
      className: `${baseClassName}__${tabMode}-close-icon`,
      name: "cross-mark"
    })
  });
};
export default TabClose;